import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { DelaStarIcon } from '~/modules/common/components';
import { useMarkAttachmentsAsRead } from '~/modules/attachments/AttachmentsBlock/hooks';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: theme.spacing(1.5, 2),
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.grey[100]
  },
  text: {
    color: theme.palette.common.white
  },
  button: {
    marginTop: theme.spacing(1.75),
    padding: theme.spacing(0.5, 1.25),
    color: theme.palette.common.white,
    boxShadow: 'none',
    textTransform: 'uppercase',
    width: 'fit-content',
    fontWeight: 400,
    fontSize: theme.spacing(1.5)
  }
}));

const useDelaStarIconStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(0.5)
  }
}));

export const DelaResourceRequestsNotification = ({ attachments }) => {
  const classes = useStyles();
  const delaStarIconClasses = useDelaStarIconStyles();
  const history = useHistory();

  const { markAttachmentsAsRead } = useMarkAttachmentsAsRead();

  const handler = useCallback(() => {
    markAttachmentsAsRead({
      binaryObjectUris: attachments.map(attachment => attachment.uploadUri)
    });
    history.push({
      pathname: `${history.location.pathname}/resourcingplan`
    });
  }, [markAttachmentsAsRead, attachments, history]);

  return (
    <div className={classes.root}>
      <DelaStarIcon classes={delaStarIconClasses} />
      <div className={classes.column}>
        <Typography variant="body2">
          <FormattedMessage id="resourceRequestsNotification.createdResourceRequests2" />
        </Typography>
        <Button
          onClick={handler}
          className={classes.button}
          variant="contained"
          color="primary"
        >
          <FormattedMessage id="resourceRequestsNotification.viewRequests" />
        </Button>
      </div>
    </div>
  );
};

DelaResourceRequestsNotification.propTypes = {
  attachments: PropTypes.array.isRequired
};

export default DelaResourceRequestsNotification;
